import http from '@/services/http';

export default {
  send (payload) {
    return http.post('/email/leadcapture', payload);
  }
}
